import { render } from "./TheCouponsIndex.vue?vue&type=template&id=5055a40f&scoped=true"
import script from "./TheCouponsIndex.vue?vue&type=script&lang=js"
export * from "./TheCouponsIndex.vue?vue&type=script&lang=js"

import "./TheCouponsIndex.vue?vue&type=style&index=0&id=5055a40f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5055a40f"

export default script